import template from './skill_competency_data_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class SkillsCompetencyDataHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class SkillsCompetencyDataHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new SkillsCompetencyDataHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'SkillsCompetencyDataHelp',
	dialog_class: SkillsCompetencyDataHelpPage,
	template: template,
	template_filename: 'translation/dialogs/outstanding_data_help',
	provider: 'ps'
};
